import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { ErrorBoundary } from './ErrorBoundary';
import { TopBar } from './TopBar';
import { SubNav } from './SubNav';
import { MobileNavDrawer } from './MobileNavDrawer';
import { MobileBottomNav } from './MobileBottomNav';
import { TesterFeedbackWidget } from './TesterFeedbackWidget';
import { useTsoftSSE } from '../hooks/useOrderSSE';
import { useViewport } from '../hooks/useViewport';

interface LayoutProps {
  onLogout?: () => void;
}

export function Layout({ onLogout }: LayoutProps) {
  const location = useLocation();
  const { isPhone, isTablet, isDesktop, isCompact } = useViewport();
  const [navOpen, setNavOpen] = useState(false);
  useTsoftSSE(); // real-time updates via SSE heartbeat

  const layoutClass = [
    'layout',
    isPhone ? 'layout--phone' : '',
    isTablet ? 'layout--tablet' : '',
    isCompact ? 'layout--compact' : '',
  ].filter(Boolean).join(' ');

  return (
    <div className={layoutClass}>
      <TopBar onLogout={onLogout} />
      {(isDesktop || isTablet) && <SubNav />}
      {isPhone && (
        <MobileNavDrawer open={navOpen} onClose={() => setNavOpen(false)} />
      )}

      <main className="content">
        <ErrorBoundary key={location.pathname}>
          <Outlet />
        </ErrorBoundary>
      </main>

      {isPhone && <MobileBottomNav onMore={() => setNavOpen(true)} />}
      <TesterFeedbackWidget />
    </div>
  );
}
